// Copyright The OpenTelemetry Authors
// SPDX-License-Identifier: Apache-2.0

// Session Replay privacy. Sensitive markup opts in with data-private and these
// are the selectors Faro is configured with.
//
// mask  — the element's text, and its descendants', becomes asterisks.
// block — the element is recorded as an empty placeholder of the same size.
//         Sensitive inputs are blocked rather than ignored: ignoreSelector only
//         drops incremental input events, and the five-minute full snapshot
//         serializes input values by type.
export const MASK_TEXT_SELECTOR = '[data-private="mask"]';
export const BLOCK_SELECTOR = '[data-private="block"]';

// Masked by input type wherever they appear, with no attribute needed.
export const MASK_INPUT_OPTIONS = {
  password: true,
  email: true,
  tel: true,
} as const;
